import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _8fc7e650 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _3ad6cb50 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _61923573 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _1938cb6a = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _12c0d6eb = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _2726cb2b = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _7acab2a9 = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _352ca544 = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _00b63c66 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _1491fe24 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _28a24342 = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _2042e8e4 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _7656f114 = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _54e0732a = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _3f4cb4a3 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _9e500664 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _31bb4835 = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _2fa581aa = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _73f8a060 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _717201a0 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _1da1aa56 = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _4afed532 = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _e74e264a = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _52f7a4b2 = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _a901ee10 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _511345a6 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _429d2ca2 = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _730f14b3 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _21c9be51 = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _2cc4deb7 = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _74445624 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _7d551d42 = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _170c260a = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _ef5dc47c = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _86f48bf8 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _0ef07940 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _f72e880a = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _b3d83eba = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _4673ca8a = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _280b0856 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _4d7cbb56 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _de1d59be = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _f47c0504 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _6510636f = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _9d09b69c = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _0771c8be = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _3a559f30 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _2692f782 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _5b17cdec = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _13b9ddac = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _79b93f31 = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _7fceaf0e = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _7a92e3c6 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _a19aa690 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _04bf83eb = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _05348850 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _ce881d5a = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _4654282c = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _2a0c2e8e = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _05b67c24 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _e00a27f0 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _a69eb04a = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _0ea022f2 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _05afa8aa = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _3d5b8123 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _6f113580 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _41f60eca = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _325a2747 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _63dd9813 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _62aa1916 = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _e9e7a3ac = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _3c13b584 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _10195cd8 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _729d9046 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _a115841c = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _a5d3cd14 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _8fc7e650,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _3ad6cb50,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _61923573,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _1938cb6a,
    name: "calendar"
  }, {
    path: "/customer",
    component: _12c0d6eb,
    name: "customer"
  }, {
    path: "/details",
    component: _2726cb2b,
    name: "details"
  }, {
    path: "/goals",
    component: _7acab2a9,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _352ca544,
    name: "maisoku"
  }, {
    path: "/media",
    component: _00b63c66,
    name: "media"
  }, {
    path: "/privacy",
    component: _1491fe24,
    name: "privacy"
  }, {
    path: "/project",
    component: _28a24342,
    name: "project"
  }, {
    path: "/response",
    component: _2042e8e4,
    name: "response"
  }, {
    path: "/sale",
    component: _7656f114,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _54e0732a,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _3f4cb4a3,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _9e500664,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _31bb4835,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _2fa581aa,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _73f8a060,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _717201a0,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _1da1aa56,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _4afed532,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _e74e264a,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _52f7a4b2,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _a901ee10,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _511345a6,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _429d2ca2,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _730f14b3,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _21c9be51,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _2cc4deb7,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _74445624,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _7d551d42,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _170c260a,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _ef5dc47c,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _86f48bf8,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _0ef07940,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _f72e880a,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _b3d83eba,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _4673ca8a,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _280b0856,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _4d7cbb56,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _de1d59be,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _f47c0504,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _6510636f,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _9d09b69c,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _0771c8be,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _3a559f30,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _2692f782,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _5b17cdec,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _13b9ddac,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _79b93f31,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _7fceaf0e,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _7a92e3c6,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _a19aa690,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _04bf83eb,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _05348850,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _ce881d5a,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _4654282c,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _2a0c2e8e,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _05b67c24,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _e00a27f0,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _a69eb04a,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _0ea022f2,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _05afa8aa,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _3d5b8123,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _6f113580,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _41f60eca,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _325a2747,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _63dd9813,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _62aa1916,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _e9e7a3ac,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _3c13b584,
    name: "property-property",
    children: [{
      path: "contact",
      component: _10195cd8,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _729d9046,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _a115841c,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _a5d3cd14,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
